<template>
  <!-- <loader :loading="loading" v-if="loading" /> -->
  <div class="dashboard-container">
    <!-- <div class="chart-container">
      <card-component class="first" title="Resellers">
        <resellers-line
          :options="{responsive: false, maintainAspectRatio: false}"
          :width="510"
          :height="280"
          :data="smsReportChartData"
        ></resellers-line>
        <div class="search-container">
          <search-input
            class="search-input"
            type="text"
            :value="search"
            @input="handleSearch"
            @keyup.enter.native="getSmsReportList"
            placeholder="Search"
          />
          <secondary-button @click.native="getSmsReportList" class="secondary-button">Filter</secondary-button>
        </div>
        <div class="resellers-table table-header">
          <div>
            <span>Company</span>
          </div>
          <div>
            <span>Date</span>
          </div>
          <div>
            <span>Sms Count</span>
          </div>
        </div>
        <div v-for="(smsReport, k) in report" :key="k" class="resellers-table table-body">
          <div>
            <span>{{smsReport.companyName}}</span>
          </div>
          <div>
            <span>{{smsReport.date}}</span>
          </div>
          <div>
            <span>{{smsReport.smsCount}}</span>
          </div>
        </div>
        <p class="pagination-link" @click="showMore" v-if="is_showMore">Show more</p>
      </card-component>
      <div class="second-charts-wrapper">
        <card-component class="second" title="Visits">
          <bar-chart
            :options="{responsive: false, maintainAspectRatio: false}"
            :width="230"
            :height="100"
          ></bar-chart>
        </card-component>
        <card-component class="third" title="Activity">
          <bar-chart-second
            :options="{responsive: false, maintainAspectRatio: false}"
            :width="230"
            :height="100"
          ></bar-chart-second>
        </card-component>
        <card-component class="forth" title="Companies">
          <companies-line
            :options="{responsive: false, maintainAspectRatio: false}"
            :width="510"
            :height="280"
          ></companies-line>
        </card-component>
        <card-component class="second" title="Visits">
          <bar-chart
            :options="{responsive: false, maintainAspectRatio: false}"
            :width="230"
            :height="100"
          ></bar-chart>
        </card-component>
        <card-component class="third" title="Activity">
          <bar-chart-second
            :options="{responsive: false, maintainAspectRatio: false}"
            :width="230"
            :height="100"
          ></bar-chart-second>
        </card-component>
      </div>
    </div>-->
  </div>
</template>

<script>
// import { format } from "date-fns";
// import { mapGetters, mapActions } from "vuex";

export default {
  // components: {
  //   ResellersLine: () =>
  //     import("@/components/Charts/Reporting/ResellersLine.js"),
  //   CompaniesLine: () =>
  //     import("@/components/Charts/Reporting/CompaniesLine.js"),
  //   BarChart: () => import("@/components/Charts/Dashboard/BarChart.js"),
  //   BarChartSecond: () => import("@/components/Charts/Dashboard/BarChart2.js"),
  //   SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
  //   SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
  //   CardComponent: () => import("@/components/CardComponent.vue"),
  //   Loader: () => import("@/components/Loader.vue"),
  // },
  // data: () => ({
  //   search: "",
  //   resellers: [
  //     { name: "Nellie Ferguson", date: "29 Apr 2018", status: true },
  //     { name: "Lou Haynes", date: "06 Nov 2018", status: false },
  //     { name: "Nellie Ferguson", date: "29 Apr 2018", status: true },
  //   ],
  //   companyName: "",
  //   chartData: [],
  //   page: 1,
  //   is_showMore: true,
  //   loading: false,
  // }),
  // computed: {
  //   ...mapGetters({
  //     smsReport: "smses/getSmsReport",
  //     reportTotalItems: "smses/getSmsReportTotal",
  //     smsReportTotalPages: "smses/getSmsReportTotalPages",
  //   }),
  //   report() {
  //     return this.smsReport.map((i) => ({
  //       companyName: i.company_name,
  //       date: format(i.date, "D MMM YYYY"),
  //       smsCount: i.sms_count,
  //       cost: i.cost,
  //     }));
  //   },
  //   smsReportChartData() {
  //     var smsCountValues = new Array(this.lastDay);
  //     smsCountValues.fill(0);
  //     var companyNames = new Array(this.lastDay);
  //     companyNames.fill("");
  //     var arrDate = new Array(this.lastDay);
  //     arrDate.fill(0);
  //     arrDate = arrDate.map((i, k) => (i = ++k));
  //     this.chartData.map((item) => {
  //       let day = new Date(item.date);
  //       day = day.getUTCDate();
  //       smsCountValues[day] += item.sms_count;
  //       companyNames[day] = item.company_name;
  //     });
  //     return { arrDate, smsCountValues, companyNames };
  //   },
  //   firstDayDate() {
  //     let date = new Date();
  //     return new Date(date.getFullYear(), date.getMonth(), 1);
  //   },
  //   lastDayDate() {
  //     let date = new Date();
  //     return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  //   },
  //   lastDay() {
  //     let date = new Date();
  //     return new Date(date.getFullYear(), date.getFullYear(), 0).getDate();
  //   },
  //   // loading() {
  //   //   return this.$store.getters["smses/getLoading"];
  //   // }
  // },
  // created: async function () {
  //   await this.getSmsReports();
  //   await this.getSmsReportList();
  // },
  // methods: {
  //   ...mapActions({
  //     viewSmsReport: "smses/getSmsReport",
  //   }),
  //   getSmsReports: async function () {
  //     const date_gte = format(this.firstDayDate, "YYYY-MM-DD");
  //     const date_lte = format(this.lastDayDate, "YYYY-MM-DD");
  //     await this.viewSmsReport({
  //       date_gte: date_gte,
  //       date_lte: date_lte,
  //     });
  //     const { items } = await this.viewSmsReport({
  //       per_page: this.reportTotalItems,
  //       date_gte: date_gte,
  //       date_lte: date_lte,
  //     });
  //     this.chartData = items;
  //   },
  //   getSmsReportList: async function () {
  //     const date_gte = format(this.firstDayDate, "YYYY-MM-DD");
  //     const date_lte = format(this.lastDayDate, "YYYY-MM-DD");
  //     await this.viewSmsReport({
  //       per_page: this.page * 3,
  //       company_name: this.search,
  //       // date_gte: date_gte,
  //       // date_lte: date_lte,
  //     });
  //   },
  //   showMore: async function () {
  //     if (this.reportTotalItems >= this.page * 3) {
  //       this.is_showMore = false;
  //       // this.page++;
  //       // this.getSmsReportList();
  //       await this.viewSmsReport({
  //         per_page: this.reportTotalItems,
  //         company_name: this.search,
  //       });
  //     }
  //   },
  //   handleSearch(search) {
  //     this.search = search;
  //     this.page = 0;
  //     //this.getSmsReportList();
  //   },
  // },
};
</script>

<style lang="scss" scoped>
// .dashboard-container {
//   padding: 20px;
//   .chart-container {
//     display: flex;
//     margin-bottom: 20px;
//     .first {
//       margin-right: 20px;
//       width: 540px;
//       height: fit-content;
//     }
//     .second {
//       width: 214px;
//       height: 170px;
//       margin-bottom: 20px;
//     }
//     .third {
//       width: 214px;
//       height: 170px;
//       margin-bottom: 20px;
//       margin-left: 4px;
//     }
//     .forth {
//       width: 450px;
//       margin-bottom: 20px;
//     }

//     .search-container {
//       margin-top: 10px;
//       margin-bottom: 10px;
//       display: flex;
//       justify-content: space-between;
//       align-items: center;
//       height: 36px;
//       .search-input {
//         height: 36px;
//         width: 417px;
//       }
//       .secondary-button {
//         height: 36px;
//         width: 80px;
//       }
//     }
//     .resellers-table {
//       height: 37px;
//       display: flex;
//       align-items: center;
//       justify-content: space-between;
//       padding: 0 15px 0 15px;
//       box-shadow: inset 0 -1px 0 0 #dfe3e8;
//       div {
//         width: 33%;
//       }
//     }
//     .table-header {
//       color: #212b36;
//       font-family: "Helvetica Neue";
//       font-size: 14px;
//       font-weight: 600;
//       line-height: 16px;
//     }
//     .table-body {
//       color: #212b36;
//       font-family: "Helvetica Neue";
//       font-size: 14px;
//       line-height: 20px;
//       justify-content: left;
//       .status {
//         height: 24px;
//         border: 2px solid #ffffff;
//         border-radius: 100px;
//         box-sizing: border-box;
//         padding: 2px 8px 2px 8px;
//         width: fit-content;
//         font-family: "Helvetica Neue";
//         font-size: 13px !important;
//         line-height: 16px;
//       }
//       .active {
//         background-color: #24e2b8;
//       }
//       .deactive {
//         background-color: #d2305b;
//         color: #fff;
//       }
//     }
//     .pagination-link {
//       cursor: pointer;
//       margin-top: 10px;
//       text-align: center;
//       color: #51a3f3;
//       font-family: "Helvetica Neue";
//       font-size: 13px;
//       line-height: 15px;
//     }
//     //   .chart-header {
//     //     width: 100%;
//     //     height: 30px;
//     //     margin-bottom: 20px;
//     //     display: flex;
//     //     justify-content: space-between;
//     //     align-items: center;
//     //     img {
//     //       cursor: pointer;
//     //     }
//     //   }
//     // }
//   }
//   .second-charts-wrapper {
//     width: 450px;
//     display: flex;
//     justify-content: space-between;
//     flex-wrap: wrap;
//   }
// }
</style>
